import { PlanType } from '../types/planType';

export const createUpgradeBannerText = (
  planType: PlanType,
  planName: string
): string => {
  return `Congrats! Your ${planType} plan has been upgraded to ${planName}. Your new features will be ready for you in just a few minutes.`;
};
